module.exports = __webpack_public_path__ + "static/media/verification.3856a7eb.svg";